export default "/images/payment_method.png?be61869c555330341a2fcd765c471ccc";